'use strict';

var _ = require('lodash');

function DialogDirective ($animate, $document, $q, $timeout, PositionService) {

  function postLink ($scope, $el, attrs, ctrl, $transclude) {
    var unbindWatchPos; // unbind watch position
    var unbindWatchMinimize; // unbind watch minimize
    var $mask;
    var $dialogContainer = $el.children().eq(0);

    $dialogContainer.on('click', function (e) {
      e.stopPropagation();
    });

    $scope.$watch(ctrl.getAttrFn('show'), onShowChange);

    ///////////////////////////////////////////////////////////////////////////////////////////////
    // Event Handlers
    ///////////////////////////////////////////////////////////////////////////////////////////////

    function onShowChange (show) {
      if (show) {
        ctrl.loadView(ctrl.view);
        unbindWatchPos = $scope.$watch(ctrl.getAttrFn('position'), function (newPos, oldPos) {
          if (newPos !== oldPos) {
            if (ctrl.show && ctrl.animate) {
              doAnimOut()
              .then(function () {
                onPositionChange(newPos, oldPos);
              });
            } else {
              onPositionChange(newPos, oldPos);
            }
          } else {
            onPositionChange(newPos, oldPos);
          }
        });

        unbindWatchMinimize = $scope.$watch(ctrl.getAttrFn('minimize'), onMinimizeChange);

        doAnimIn();
      } else {
        cleanupWatch();
        doAnimOut();
      }

      addMask();
      toggleMask($mask, show);
    }

    function onMinimizeChange (minimize) {
      if (minimize) {
        $animate.addClass($dialogContainer, 'minimize');
        $dialogContainer.css({
          height: ctrl.minimizeHeight,
        });
      } else if (!minimize) {
        $dialogContainer.css({
          height: null
        });
        $animate.removeClass($dialogContainer, 'minimize');
      }
    }

    function onPositionChange (newPosition, oldPosition) {
      var styles; // existing styles

      // remove the old class if applicable
      if (typeof oldPosition === 'string') {
        $dialogContainer.removeClass(oldPosition);
      }
      
      // save original styles so we can reapply later
      styles = getStylesObj($dialogContainer.attr('style'));

      // force layout so position calculations are accurate (but keep hidden)
      $dialogContainer.css({
        display: 'block',
        visibility: 'hidden'
      });

      if (Array.isArray(newPosition)) {
        var align = ctrl.align;

        // reset margins before calculating position
        $dialogContainer.css({
          marginBottom: 0,
          marginLeft: 0,
          marginRight: 0,
          marginTop: 0
        });

        $timeout(function () {
          var pos = PositionService.getAdjustedPosition($dialogContainer, newPosition, align);

          if (ctrl.beforeMove) {
            ctrl.beforeMove();
          }

          // apply the new position
          $dialogContainer.removeAttr('style');
          $dialogContainer.css(_.extend({}, styles, {
            left: addUnits(pos.left),
            top: addUnits(pos.top)
          }));

        }, 10);
      } else {
        $timeout(function () {
          if (newPosition === 'center') {
            var marginLeft = -($dialogContainer[0].offsetWidth/2);
            var marginTop = -($dialogContainer[0].offsetHeight/2);

            $dialogContainer.removeAttr('style');
            $dialogContainer.css(_.extend({}, styles, {
              left: '50%',
              top: '50%',
              marginLeft: addUnits(marginLeft),
              marginTop: addUnits(marginTop)
            }));
          } else {
            $dialogContainer.removeAttr('style');
            if (ctrl.minimize) {
              $dialogContainer.css(_.extend({}, styles, {
                height: ctrl.minimizeHeight,
              }));
            }
            $dialogContainer.addClass(newPosition);
          }
        }, 10);
      }

      doAnimIn();
    }

    /////////////////////////////////////////////////////////////////////////////////////////////////
    // Utility Functions
    /////////////////////////////////////////////////////////////////////////////////////////////////

    function addMask () {
      // add the background mask if needed
      if (attrs.mask && !$mask) {
        var $body = $document.find('body').eq(0);
        var mask = $body[0].querySelector('.dialog-bg-mask');

        if (!mask) {
          $mask = angular.element('<div class="dialog-bg-mask"></div>');
          $mask.css({display: 'none'});
          $body.append($mask);
        } else {
          $mask = angular.element(mask);
        }
      }
    }

    function addUnits (number, units) {
      units = units || 'px';
      return number + units;
    }

    function cleanupWatch () {
      if (unbindWatchPos) {
        unbindWatchPos();
      }

      if (unbindWatchMinimize) {
        unbindWatchMinimize();
      }
    }

    function doAnimIn () {
      // make sure the hide class is on the element (otherwise it won't animate)
      $dialogContainer.addClass('hide');

      if (!ctrl.animate) {
        var deferred = $q.defer();

        $dialogContainer.removeClass('hide');
        deferred.resolve();

        return deferred.promise;
      } else {
        var animation = ctrl.animate.split(' ')[0];
        var animationClasses = 'animated ' + animation;

        $dialogContainer.addClass(animationClasses);

        return $animate.removeClass($dialogContainer, 'hide')
        .then(function () {
          $dialogContainer.removeClass(animationClasses);
        });
      }
    }

    function doAnimOut () {
      if (!ctrl.animate) {
        var deferred = $q.defer();

        $dialogContainer.addClass('hide');
        deferred.resolve();

        return deferred.promise;
      } else {
        var animation = ctrl.animate.split(' ')[1];
        var animationClasses = 'animated ' + animation;

        $dialogContainer.addClass(animationClasses);

        return $animate.addClass($dialogContainer, 'hide')
        .then(function () {
          $dialogContainer.removeClass(animationClasses);
        });
      }

    }

    function getStylesObj (styles_) {
      if (styles_) {
        return _.reduce(styles_.split(';'), function (styles, style) {
          if (style) {
            var arr = style.split(':');
            styles[arr[0].trim()] = arr[1].trim();
          }
          return styles;
        }, {});
      } else {
        return {};
      }
    }

    function toggleMask ($mask, show) {
      if ($mask) {
        if (show) {
          $mask.css({display: 'block'});
        } else {
          $mask.css({display: 'none'});
        }
      }
    }
  }


  /////////////////////////////////////////////////////////////////////////////////////////////////
  // Directive Definition Object
  /////////////////////////////////////////////////////////////////////////////////////////////////

  return {
    bindToController: true,
    controller: 'sbDialogController',
    controllerAs: 'dialogCtrl',
    link: {
      post: postLink
    },
    scope: {
      align: '@', // one of 'top left', 'top right', 'top center', bottom left', 'bottom right', 'bottom center', 'center left', 'center right'
      animate: '=?', // two animate.css classes, first is the enter animation, second is the exit animation
      dimen: '@', // only used when position is "center"
      beforeMove: '&', // callback to execute before the dialog moves to its new position (only applicable for xy position)
      controls: '@', // dialog controls to activate, defaults to "close" (possible values: {"close,minimize" | "close" | "minimize" | "")
      group: '@',
      mask: '=?',
      minimize: '=?',
      minimizeHeight: '@', // height when minimized, defaults to "30px"
      position: '=?', // one of 'top left', 'top right', 'bottom left', 'bottom right', 'center', or '[x,y]' coordinate array
      show: '=?',
      view: '=?', // currenty visible view
    },
    templateUrl: 'saturn/dialog/dialog.tpl.html',
    transclude: true
  };
}

DialogDirective.$inject = ['$animate', '$document', '$q', '$timeout', 'sbPositionService'];
module.exports = DialogDirective;


// WEBPACK FOOTER //
// ./~/@skycatch/skydash-saturn/boosters/dialog/src/DialogDirective.js